<template>
  <div class="playlist">
    <nav class="navbar navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <div class="navbar-brand">Playlist for {{ $date(playlist.date).format('dddd, MMMM D') }}</div>

        <div class="nav-item" v-b-modal="'edit-playlist'">
          <div class="btn btn-outline-secondary">
            <b-icon-pencil></b-icon-pencil>
          </div>
        </div>
      </div>
    </nav>
    
    <Modal id="edit-playlist">
      <template v-slot:header>
        Edit playlist for {{ $date(playlist.date).format('dddd, MMMM D') }}
      </template>

      <template v-slot:content="{ changed, close }">
        <Editor :playlist="playlist" v-on="{ changed, saved: updated(close) }"></Editor>
      </template>
    </Modal>
    
    <div class="playlist-content-container">
      <div class="playlist-content">
        <Empty v-if="$apollo.queries.playlist.loading" icon="b-icon-hourglass-split" header="Loading"></Empty>
        <div v-else class="row no-gutters h-100">
          <div class="col-sm-4 h-100">
            <KeyNav :keyLevel="2" :size="playlist.song_listings.length" @selected="selectAtIndex" @deselected="escaped">
              <template v-slot:default="{ preselected }">
                <div class="list-group">
                  <router-link v-for="(listing, index) in playlist.song_listings" :key="index" class="list-group-item" :class="[{ 'list-group-item-dark': preselected === index }]" active-class="active" :to="{ name: 'playlist.song', params: { playlistId: playlist.id, songId: listing.song.id }}">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{ listing.song.title }}</h5>
                    </div>
                  </router-link>
                </div>
              </template>
            </KeyNav>
          </div>

          <div class="col-sm-8 h-100">
            <router-view></router-view>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  import Modal from '../components/Editor';
  import Editor from '../components/editors/Playlist';
  import Empty from '../components/Empty';
  import KeyNav from '../components/KeyNav'

  export default {
    components: {
      Modal,
      Editor,
      Empty,
      KeyNav
    },

    beforeRouteUpdate(to, from, next) {
      this.id = to.params.playlistId;
      next();
    },

    data() {
      return {
        id: this.$route.params.playlistId,
        playlist: {}
      }
    },

    methods: {
      positioned(position) {
        this.$store.dispatch('positioned', position)
      },

      updated(callback) {
        return function({ updated_at }) {
          callback();
          this.$store.dispatch('updated', updated_at)
        }.bind(this);
      },

      selectAtIndex(index) {
        const listing = this.playlist.song_listings[index];
        this.$router.push({ name: 'playlist.song', params: { songId: listing.song_id } })
      },

      escaped() {
        this.$router.push({ name: 'playlists.index' })
      }
    },  

    apollo: {
      playlist: {
        query: gql`
          query GetPlaylist($id: uuid!) {
            playlist: playlists_by_pk(id: $id) {
              id
              date
              comments

              song_listings {
                song_id
                playlist_id

                song {
                  id
                  title
                  body
                }
              }

              created_at
              updated_at
            }
          }
        `,

        variables() {
          return {
            id: this.id
          }
        }
      }
    }
  }
</script>

<style scoped>
  .playlist {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .playlist-content-container {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .playlist-content {
    flex: 1;
    overflow: auto;

    position: relative;
  }

  .playlist-content > .row > :first-child {
    border-right: 1px solid #ccc;
  }

  .playlist-content > .row > :last-child {
    border-left: 1px solid #eee;
  }
</style>
